import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  unreadCount: 0,
  notifications: [],
  loading: false,
  error: null,
  lastFetched: null,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    incrementUnreadCount: (state) => {
      state.unreadCount += 1;
    },
    decrementUnreadCount: (state) => {
      if (state.unreadCount > 0) state.unreadCount -= 1;
    },
    resetUnreadCount: (state) => {
      state.unreadCount = 0;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
      state.lastFetched = new Date().toISOString();
    },
    appendNotifications: (state, action) => {
      const existingIds = new Set(state.notifications.map((n) => n._id));
      const fresh = action.payload.filter((n) => !existingIds.has(n._id));
      state.notifications = [...state.notifications, ...fresh];
      state.lastFetched = new Date().toISOString();
    },
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
      if (!action.payload.isRead) state.unreadCount += 1;
    },
    markNotificationAsRead: (state, action) => {
      const n = state.notifications.find((x) => x._id === action.payload);
      if (n && !n.isRead) {
        n.isRead = true;
        n.readAt = new Date().toISOString();
        if (state.unreadCount > 0) state.unreadCount -= 1;
      }
    },
    markAllAsRead: (state) => {
      state.notifications.forEach((n) => {
        if (!n.isRead) {
          n.isRead = true;
          n.readAt = new Date().toISOString();
        }
      });
      state.unreadCount = 0;
    },
    removeNotification: (state, action) => {
      const idx = state.notifications.findIndex((n) => n._id === action.payload);
      if (idx !== -1) {
        if (!state.notifications[idx].isRead && state.unreadCount > 0) state.unreadCount -= 1;
        state.notifications.splice(idx, 1);
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearNotifications: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
      state.lastFetched = null;
    },
  },
});

export const {
  setUnreadCount,
  incrementUnreadCount,
  decrementUnreadCount,
  resetUnreadCount,
  setNotifications,
  appendNotifications,
  addNotification,
  markNotificationAsRead,
  markAllAsRead,
  removeNotification,
  setLoading,
  setError,
  clearNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
